import { z } from 'zod';

export type TaxMapping = z.infer<typeof TaxMapping>;
export const TaxMapping = z.object({
    tax: z.number(),
    taxId: z.number(),
});
